module.exports = __webpack_public_path__ + "static/media/healthcare.7b1d3e60.svg";